import { useState } from "react";
import "./saveAnalysisModal.css";

interface SaveAnalysisModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (analysisName: string) => void;
}

const SaveAnalysisModal = ({ isOpen, onClose, onSave }: SaveAnalysisModalProps) => {
    const [analysisName, setAnalysisName] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const handleSave = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!analysisName.trim()) {
            return;
        }

        setIsSaving(true);
        try {
            await onSave(analysisName);
            resetForm();
            onClose();
        } catch (error) {
            console.error("Error saving analysis:", error);
        } finally {
            setIsSaving(false);
        }
    };

    const resetForm = () => {
        setAnalysisName("");
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="save-analysis-overlay" onClick={handleClose}>
            <div className="save-analysis-wrapper">
                <button className="save-analysis-close" onClick={handleClose}>
                    ×
                </button>
                <div className="save-analysis-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="save-analysis-content">
                        <h2 className="save-analysis-title">Save Analysis</h2>

                        <form className="save-analysis-form" onSubmit={handleSave}>
                            <div className="save-analysis-input-group">
                                <label htmlFor="analysisName" className="save-analysis-label">
                                    Analysis Name *
                                </label>
                                <input
                                    id="analysisName"
                                    type="text"
                                    placeholder="Enter analysis name"
                                    value={analysisName}
                                    onChange={(e) => setAnalysisName(e.target.value)}
                                    className="save-analysis-input"
                                    required
                                    autoFocus
                                />
                            </div>

                            <div className="save-analysis-buttons">
                                <button
                                    type="submit"
                                    className="save-analysis-button"
                                    disabled={isSaving || !analysisName.trim()}
                                >
                                    {isSaving ? "Saving..." : "Save →"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SaveAnalysisModal;
